import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { PackageTypeEnum, PlantsEnum, QualityTypeEnum, SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
export class IndentItemsModel {
    @ApiProperty()
    @IsNotEmpty({ message: "Indent Item Id should not be empty" })
    @IsNumber()
    indentItemId: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Indent Id should not be empty" })
    @IsNumber()
    indentId: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Farmer should not be empty" })
    @IsNumber()
    farmer: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Farmer Code should not be empty" })
    @IsNumber()
    farmerCode: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    broker?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Product should not be empty" })
    @IsNumber()
    product: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Expected Count should not be empty" })
    @IsNumber()
    expectedCount: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Expected Quantity should not be empty" })
    @IsNumber()
    expectedQty: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Expected Price should not be empty" })
    @IsNumber()
    expectedPrice: number;

    @ApiProperty()
    @IsNumber()
    expectedCount2: number;

    @ApiProperty()
    @IsNumber()
    expectedPrice2: number;

    @ApiProperty()
    @IsNumber()
    expectedCount3: number;

    @ApiProperty()
    @IsNumber()
    expectedPrice3: number;

    @ApiProperty()
    @IsNumber()
    expectedCount4: number;

    @ApiProperty()
    @IsNumber()
    expectedPrice4: number;

    @ApiProperty()
    @IsNumber()
    rmRate: number;

    @ApiProperty()
    @IsNumber()
    iceRate: number;

    @ApiProperty()
@IsOptional()
quality: QualityTypeEnum;

@ApiProperty()
@IsOptional()
packageType: PackageTypeEnum;

@ApiProperty()
@IsOptional()
grossWeight: number;

@ApiProperty()
@IsOptional()
boeNum: string;

@ApiProperty()
@IsOptional()
boeDate: Date;

@ApiProperty()
@IsOptional()
netweight: number;

@ApiProperty()
@IsOptional()
tareWeight: number;


}